import { render } from "./FaqElement.vue?vue&type=template&id=3ae30295&scoped=true"
import script from "./FaqElement.vue?vue&type=script&lang=js"
export * from "./FaqElement.vue?vue&type=script&lang=js"

import "./FaqElement.vue?vue&type=style&index=0&id=3ae30295&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae30295"]])

export default __exports__